//document.addEventListener("DOMContentLoaded", function () {});
//let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

// GLOBAL: add padding to first element after header 
let h = document.querySelector("#header");
let hH = h.offsetHeight;
let hNext = h.nextElementSibling;
let hNextP = parseInt(window.getComputedStyle(hNext, null).getPropertyValue('padding-top'));
hNext.style.cssText += 'padding-top:' + (hNextP + hH) + 'px;';



// GLOBAL: grab query vars from URL
const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

// if agent_code is present > 
// always add to hrefs (home, order) to be passed to next page 
// ignore hrefs with '#'
function add_agent_code(ac) {
  let links = document.getElementsByTagName('a');
  for (let i = 0; i < links.length; i++) {
    //console.log(links[i]);
    links[i].href.indexOf('#') == -1 ?
      links[i].href += links[i].href.indexOf('?') == -1 ? '?agent_code=' + ac :
        links[i].href.indexOf('agent_code') == -1 ? '&agent_code=' + ac : '' : '';
  }
}
params.agent_code ? add_agent_code(params.agent_code) : '';




// HOME >> (Welcome Section): click event listeners 
let welcome_section = !!document.querySelector("#welcome_section");
// if #welcome-buckets exists we're on the home page  
if (welcome_section) {
  document.addEventListener('click', function (e) {
    if (e.target.closest('.welcome-bucket')) {
      e.preventDefault();
      let scrollTo;
      e.target.tagName.toLowerCase() === 'div' ?
        scrollTo = e.target.querySelector('a').getAttribute('href') :
        scrollTo = e.target.getAttribute('href');
      document.querySelector(scrollTo).scrollIntoView({
        behavior: 'smooth'
      });
    }
    // console.log(event.target);
  }, false);
}



// ORDER PAGE: 
//let order_page = !!document.querySelector("#order_page");
// if #order_page exists we're on the order page  


// CHECKOUT PAGE: 
let checkout_page = !!document.querySelector("#checkout_page");
// if #checkout_page exists we're on the checkout page  
if (checkout_page) {
  let service_type = document.getElementById('service_type');
  let service_fee = document.getElementById('service_fee');
  let setup_fee = document.getElementById('setup_fee');
  let reservation_fee = document.getElementById('reservation_fee');
  let totals = document.querySelectorAll('.total-due');
  let price_displays = document.querySelectorAll('.price-display');
  let order_btn = document.querySelector('#order_btn');
  // hidden (calc) inputs 
  let calc_service_fee = document.getElementById('calc_service_fee');
  let calc_setup_fee = document.getElementById('calc_setup_fee');
  let calc_reservation_fee = document.getElementById('calc_reservation_fee');
  let calc_total_due = document.getElementById('calc_total_due');

  if (!params.service) {
    service_type.textContent = 'Business'; //default to business 
  } else {
    service_type.textContent = params.service;
  }
  //
  if (params.service == 'Standard') {
    service_fee.textContent = standard_fee;
    setup_fee.textContent = standard_setup_fee;
    reservation_fee.textContent = standard_reservation_fee;
  } else if (params.service == 'Backup') {
    service_fee.textContent = backup_fee;
    setup_fee.textContent = backup_setup_fee;
    reservation_fee.textContent = backup_reservation_fee;
  } else {
    service_fee.textContent = business_fee;
    setup_fee.textContent = business_setup_fee;
    reservation_fee.textContent = business_reservation_fee;
  }
  // add agent_code to #agent_code input 
  params.agent_code ? document.getElementById('agent_code').value = params.agent_code : '';
  //
  let checkout_total, monthly_fee;

  monthly_fee = parseFloat(service_fee.textContent);
  monthly_fee = monthly_fee.toLocaleString('en-US', { minimumFractionDigits: 2 });
  //checkout_total = parseFloat(service_fee.textContent) + parseInt(setup_fee);
  checkout_total = parseInt(reservation_fee.textContent);
  //
  checkout_total = checkout_total.toLocaleString('en-US', { minimumFractionDigits: 2 });
  //
  price_displays.forEach(function (pd) {
    pd.querySelector('.is-total').classList.replace('d-none', 'd-inline-flex');
    //pd.querySelector('.no-total').classList.replace('d-inline-flex', 'd-none');
    pd.querySelector('.if-monthly').classList.replace('d-none', 'd-flex');
  });

  calc_service_fee.value = service_fee.textContent;
  calc_setup_fee.value = setup_fee;
  calc_reservation_fee.value = reservation_fee.textContent;
  calc_total_due.value = checkout_total;

  totals.forEach(function (total) {
    total.textContent = checkout_total;
  });

  let terms_check = document.querySelector('#terms_check');

  /*
  console.log('Service Type: ' + service_type.textContent);
  console.log('Service Fee: ' + service_fee.textContent);
  console.log('Setup Fee: ' + setup_fee);
  console.log('Reservation Fee: ' + reservation_fee.textContent);
  console.log('Total Due: ' + checkout_total);
  */

  //console.log(checkout_total);

  document.addEventListener('click', function (e) {
    if (e.target.id == 'terms_check') {
      if (checkout_total != '') {
        terms_check.checked ? order_btn.disabled = false : order_btn.disabled = true;
      }
    }
  });

  // form validation 
  let order_form = document.querySelector('#order_form');
  //let valid_fields, nvalid_fields;
  order_form.addEventListener('submit', function (e) {
    if (!order_form.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      //valid_fields = document.querySelectorAll(':valid');
      let invalid_fields = order_form.querySelectorAll(':invalid:not(form):not(fieldset)');
      let scrollTo;
      //console.log("valid_fields: " + valid_fields);
      //console.log("invalid_fields: " + invalid_fields);
      /*for (let i = 0; i < invalid_fields.length; i++) {
        console.log(invalid_fields[i]);
      }*/
      //console.log(invalid_fields[0].id);
      scrollTo = '#' + invalid_fields[0].id;
      document.querySelector(scrollTo).scrollIntoView({
        behavior: 'smooth'
      });
    }
    order_form.classList.add('was-validated');
  }, false);

} // eof CHECKOUT PAGE 




// GLOBAL: reveal body << last 
document.body.classList.remove("init");